import { type RefObject, useEffect, useRef } from 'react';

/**
 * Phone navigation drawer: focus moves to `openFocus` inside the drawer when it opens, and back to
 * the button that opened it when it closes, unless the user already moved focus somewhere else.
 */
export function useDrawerFocus(
  open: boolean,
  drawerSelector: string,
  openFocusSelector: string,
  opener: RefObject<HTMLElement | null>,
) {
  const wasOpen = useRef(false);
  useEffect(() => {
    if (open) {
      wasOpen.current = true;
      document.querySelector<HTMLElement>(`${drawerSelector} ${openFocusSelector}`)?.focus();
      return;
    }
    if (!wasOpen.current) return;
    wasOpen.current = false;
    const active = document.activeElement;
    if (!active || active === document.body || active.closest(drawerSelector)) {
      opener.current?.focus();
    }
  }, [open, drawerSelector, openFocusSelector, opener]);
}
